<!-- 参数录入表单 -->
<template>
  <v-form ref="paramForm" :disabled="disabled">
    <v-tabs v-if="isGroup">
      <v-tab v-for="(group,index) in groupItems" :key="index">{{group.name}}</v-tab>
      <v-tab-item v-for="(group,i) in groupItems" :key="i">
        <v-row dense class="mt-2">
          <template v-for="(item,index) in group.items">
            <v-col v-if="item.newline!=false" cols="12" :key="`newline${index}`"></v-col>
            <v-col v-if="item.visible" :key="index" :cols="item.width||12">
              <template v-if="item.type==3">
                <v-select :label="item.name" v-model="billData[item.code]" :disabled="item.disabled" :items="colors[item.code]" prepend-inner-icon="mdi-plus" @click:prepend-inner="colorGroupEditorVisible=true" :placeholder="item.placeholder" item-text="name" item-value="code" @change="onValueChanged($event,item)" hide-details dense outlined>
                  <template v-slot:item="{item}">
                    <v-row no-gutters align="center">
                      <v-col cols="12" class="caption primary--text">{{item.name}}</v-col>
                      <v-col v-for="(cv,ci) in item.code.split(',')" :key="ci" cols="auto">
                        <v-chip small :color="cv" class="rounded-0"></v-chip>
                      </v-col>
                    </v-row>
                  </template>
                </v-select>
                <v-dialog v-model="colorGroupEditorVisible" max-width="350">
                  <v-card>
                    <v-card-title>自定义颜色组
                      <v-spacer />
                      <v-icon @click="colorGroupEditorVisible=false">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text>
                      <color-group-editor v-if="colorGroupEditorVisible" @change="onValueChanged($event,item)"></color-group-editor>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </template>
              <template v-else-if="item.type==4">
                <v-text-field :label="item.name" :rules="[rules.analyseContent]" v-model="billData[item.code]" :disabled="item.disabled" :placeholder="item.placeholder" @change="onValueChanged($event,item)" hide-details dense outlined></v-text-field>
              </template>
              <template v-else-if="item.type==5">
                <v-select :label="item.name" :items="coder[item.clsCode]" v-model="billData[item.code]" :disabled="item.disabled" :placeholder="item.placeholder" item-text="name" item-value="code" :clearable="!item.required" @change="onValueChanged($event,item)" hide-details dense outlined></v-select>
              </template>
              <template v-else-if="item.type==6">
                <v-slider v-model="billData[item.code]" :label="item.name" @change="onValueChanged($event,item)" :disabled="item.disabled" dense thumb-label></v-slider>
              </template>
              <template v-else-if="item.type==7">
                <v-radio-group v-model="billData[item.code]" @change="onValueChanged($event,item)" :disabled="item.disabled" :label="item.name" row dense hide-details class="mt-0">
                  <v-radio v-for="(item2,index) in coder[item.clsCode]" :key="index" :label="item2.name" :value="item2.code"></v-radio>
                </v-radio-group>
              </template>
              <template v-else-if="item.type==9">
                <v-switch v-model="billData[item.code]" @change="onValueChanged($event,item)" :disabled="item.disabled" dense hide-details inset class="mt-0">
                  <template v-slot:prepend>
                    <div style="white-space:nowrap;color:#00000099;" class="v-label mr-2">{{item.name}}</div>
                  </template>
                </v-switch>
              </template>
              <template v-else-if="item.type==10">
                <int-editor v-model="billData[item.code]" :label="item.name" @change="onValueChanged($event,item)" :disabled="item.disabled" hide-details dense outlined></int-editor>
              </template>
              <template v-else-if="item.type==11">
                <decimal-editor v-model="billData[item.code]" :label="item.name" @change="onValueChanged($event,item)" :disabled="item.disabled" hide-details dense outlined></decimal-editor>
              </template>
            </v-col>
          </template>
        </v-row>
      </v-tab-item>
    </v-tabs>

    <v-row v-else dense>
      <template v-for="(item,index) in items">
        <v-col v-if="item.newline!=false" cols="12" :key="`newline${index}`"></v-col>
        <v-col v-if="item.visible" :key="index" :cols="item.width||12">
          <template v-if="item.type==3">
            <v-select :label="item.name" v-model="billData[item.code]" :disabled="item.disabled" :items="colors[item.code]" prepend-inner-icon="mdi-plus" @click:prepend-inner="colorGroupEditorVisible=true" :placeholder="item.placeholder" item-text="name" item-value="code" @change="onValueChanged($event,item)" hide-details dense outlined>
              <template v-slot:item="{item}">
                <v-row no-gutters align="center">
                  <v-col cols="12" class="caption primary--text">{{item.name}}</v-col>
                  <v-col v-for="(cv,ci) in item.code.split(',')" :key="ci" cols="auto">
                    <v-chip small :color="cv" class="rounded-0"></v-chip>
                  </v-col>
                </v-row>
              </template>
            </v-select>
            <v-dialog v-model="colorGroupEditorVisible" max-width="350">
              <v-card>
                <v-card-title>自定义颜色组
                  <v-spacer />
                  <v-icon @click="colorGroupEditorVisible=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                  <color-group-editor v-if="colorGroupEditorVisible" @change="onValueChanged($event,item)"></color-group-editor>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
          <template v-else-if="item.type==4">
            <v-text-field :label="item.name" :rules="[rules.analyseContent]" v-model="billData[item.code]" :disabled="item.disabled" :placeholder="item.placeholder" @change="onValueChanged($event,item)" hide-details dense outlined></v-text-field>
          </template>
          <template v-else-if="item.type==5">
            <v-select :label="item.name" :items="coder[item.clsCode]" v-model="billData[item.code]" :disabled="item.disabled" :placeholder="item.placeholder" item-text="name" item-value="code" :clearable="!item.required" @change="onValueChanged($event,item)" hide-details dense outlined></v-select>
          </template>
          <template v-else-if="item.type==6">
            <v-slider v-model="billData[item.code]" :label="item.name" @change="onValueChanged($event,item)" :disabled="item.disabled" dense thumb-label></v-slider>
          </template>
          <template v-else-if="item.type==7">
            <v-radio-group v-model="billData[item.code]" @change="onValueChanged($event,item)" :disabled="item.disabled" :label="item.name" row dense hide-details class="mt-0">
              <v-radio v-for="(item2,index) in coder[item.clsCode]" :key="index" :label="item2.name" :value="item2.code"></v-radio>
            </v-radio-group>
          </template>
          <template v-else-if="item.type==9">
            <v-switch v-model="billData[item.code]" @change="onValueChanged($event,item)" :disabled="item.disabled" dense hide-details inset class="mt-0">
              <template v-slot:prepend>
                <div style="white-space:nowrap;color:#00000099;" class="v-label mr-2">{{item.name}}</div>
              </template>
            </v-switch>
          </template>
          <template v-else-if="item.type==10">
            <int-editor v-model="billData[item.code]" :label="item.name" @change="onValueChanged($event,item)" :disabled="item.disabled" hide-details dense outlined></int-editor>
          </template>
          <template v-else-if="item.type==11">
            <decimal-editor v-model="billData[item.code]" :label="item.name" @change="onValueChanged($event,item)" :disabled="item.disabled" hide-details dense outlined></decimal-editor>
          </template>
        </v-col>
      </template>
    </v-row>
  </v-form>
</template>
<script>
// 3颜色集、4文本输入、5下拉选择、6滑动条、7单选、9开关、10整数、11小数
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { analyseContent } from '@/plugins/rules';

import { getColors } from '@/plugins/api';
import ColorGroupEditor from './Editor/ColorGroupEditor.vue';
export default {
  props: ['items', 'coder', 'disabled'],
  //props: ['wid', 'items', 'coder'],
  data () {
    return {
      billData: {},
      defaultBillData: {},
      colors: {},
      colorGroupEditorVisible: false
    }
  },
  computed: {
    rules () {
      return { analyseContent: analyseContent() }
    },
    isGroup () { return !!this.items[0].groupName },
    groupItems () {
      let ret = [];
      this.items.forEach(item => {
        let g = ret.find(row => row.name == item.groupName);
        if (!g) {
          g = { name: item.groupName, items: [] }
          ret.push(g);
        }
        g.items.push(item);
      })
      return ret;
    },
  },
  created () { this.init() },
  methods: {
    init () {
      let defaultValues = {};
      this.items.forEach(item => {
        let dv = item.dftValue;
        if (dv != undefined && dv != null && dv != '') defaultValues[item.code] = dv;
        if (item.type == 3) {
          getColors(item.colorGroupCode).then(res => this.$set(this.colors, item.code, res.data))
        }
      })
      this.defaultBillData = this.Utility.clone(defaultValues);
      this.billData = defaultValues;
    },
    validate () { return this.$refs.paramForm.validate() },
    getBillData () {
      let ret = [];
      for (let key in this.billData) {
        let value = this.billData[key]
        if (value != undefined && value != null && value != '') {
          let item = this.items.find(item => item.code == key);
          let d = { code: key, value: value };
          if (item) d.type = item.type;
          ret.push(d);
        }
      }
      return ret;
    },
    setItemProp (itemCode, propCode, propValue) {
      let item = this.items.find(item => item.code == itemCode);
      if (!item) return;
      this.$set(item, propCode, propValue);
    },
    reset () { for (let key in this.defaultBillData) this.$set(this.billData, key, this.defaultBillData[key]) },
    setItemValue (itemCode, value) { this.$set(this.billData, itemCode, value) },
    setItemValues (itemValues) { for (let key in itemValues) this.$set(this.billData, key, itemValues[key]) },
    onValueChanged (e, item) {
      let changed = item.changed;
      if (changed) {
        new Function('ξ', 'value', changed)(this, e);
        // let ξ = this;
        // eval(changed);
      }
    }
  },
  components: { ColorGroupEditor }
}
</script>